<template>
  <nav class="navbar navbar-expand admin-nav py-0">
    <div class="container-fluid px-3">
      <router-link
        :to="{ name: 'AdminIndex' }"
        class="navbar-brand admin-nav-brand d-flex align-items-center py-2"
        :class="{ active: route.name === 'AdminIndex' }"
      >
        <font-awesome-icon icon="user-shield" class="me-2" />
        Admin
      </router-link>
      <ul class="navbar-nav flex-wrap">
        <li
          v-for="group in adminNavGroups"
          :key="group.label"
          class="nav-item dropdown"
        >
          <a
            class="nav-link dropdown-toggle px-3 py-2"
            :class="{ active: isGroupActive(group) }"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ group.label }}
          </a>
          <ul class="dropdown-menu">
            <li v-for="item in visibleItems(group)" :key="item.id">
              <router-link
                class="dropdown-item d-flex align-items-center"
                :class="{ active: route.name === item.routeName }"
                :to="{ name: item.routeName, query: item.query }"
              >
                <font-awesome-icon
                  :icon="item.icon"
                  class="me-2 admin-nav-item-icon"
                  fixed-width
                />
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <span class="ms-auto d-none d-lg-inline text-body-tertiary small">
        <kbd>⌘K</kbd> to search
      </span>
    </div>
  </nav>
</template>

<script setup lang="ts">
import {
  adminNavGroups,
  type AdminNavGroup,
  type AdminNavItem,
} from "@/admin/navigation/adminNavConfig";
import { useRoute } from "vue-router";

const route = useRoute();

const visibleItems = (group: AdminNavGroup): AdminNavItem[] =>
  group.items.filter((item) => !item.paletteOnly);

const isGroupActive = (group: AdminNavGroup): boolean =>
  group.items.some((item) => item.routeName === route.name);
</script>

<style scoped lang="scss">
.admin-nav {
  background-color: var(--phoenix-body-highlight-bg);
  border-bottom: 1px solid var(--phoenix-border-color);

  .admin-nav-brand {
    font-weight: 700;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .nav-link.active,
  .admin-nav-brand.active {
    color: var(--phoenix-primary);
  }

  .admin-nav-item-icon {
    opacity: 0.6;
  }
}
</style>
